
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AircraftCard from './components/AircraftCard';

const leftColumnAircraft = [
  {
    id: 1,
    name: '1946 Cessna 140',
    tailNumber: 'NC72549',
    specs: [
      'ADSB Out',
      'Excellent Interior',
      'AV-30 PFD',
      'Dual Brakes and Harnesses',
      'Perfect Aluminum Exterior',
      '85hp Continental Motor',
      '150/hr Wet'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/d326ecd26ce4cd0dc505f22c9286868c.jpeg',
        alt: '1946 Cessna 140 NC72549 exterior view'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/78eb731e35f2e7ea9589dabdf8f859b6.jpeg',
        alt: '1946 Cessna 140 NC72549 cockpit interior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/67193242089163b496ee034662d2f9a2.jpeg',
        alt: '1946 Cessna 140 NC72549 front view'
      }
    ]
  },
  {
    id: 2,
    name: '1946 Luscombe 8A',
    tailNumber: 'N71381',
    specs: [
      'Perfect Leather Interior',
      'Maximum View Doors/Windows',
      'Exceptional Aluminum Finish',
      'Continental 75hp',
      '150/hr Wet'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/d382757a1b475db18bd9d63b5503bb46.jpeg',
        alt: '1946 Luscombe 8A N71381'
      }
    ]
  },
  {
    id: 3,
    name: '1948 Cessna 170',
    tailNumber: 'N4154V',
    specs: [
      'Immaculate 4 place interior',
      '900lb useful load',
      'Perfect Aluminum Finish',
      '175/hr Wet'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/6f59e621070cea251d90af38e3241d4b.jpeg',
        alt: '1948 Cessna 170 N4154V exterior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/dd64f862408c33ef2034c2ee86f55dd0.jpeg',
        alt: '1948 Cessna 170 N4154V interior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/23396b6844cc1c3724d4fbd9cf736e72.jpeg',
        alt: '1948 Cessna 170 N4154V front view'
      }
    ]
  },
  {
    id: 4,
    name: 'Globe Swift GC1B',
    tailNumber: 'N80969',
    specs: [
      'High Performance Complex',
      '210hp Constant Speed'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/987c7e084bfe55882cb5245a983be2e3.jpeg',
        alt: 'Globe Swift GC1B N80969'
      }
    ]
  }
];

const rightColumnAircraft = [
  {
    id: 5,
    name: '1946 Cessna 140',
    tailNumber: 'NC89306',
    specs: [
      'ADSB Out',
      'Restored Red Interior',
      'Dual Brakes and Harnesses',
      'Crisp White/Red Paint',
      '90hp Continental Motor',
      '150/hr Wet'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/8d6cee317366f3c5ca154e01714c8569.jpeg',
        alt: '1946 Cessna 140 NC89306 exterior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/5f1c7007e5bc6ffbdc39416099ae88ea.jpeg',
        alt: '1946 Cessna 140 NC89306 interior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/403196911c6279362f6bd022cc101b90.jpeg',
        alt: '1946 Cessna 140 NC89306 front view'
      }
    ]
  },
  {
    id: 6,
    name: '1959 Cessna 310C',
    tailNumber: 'N413DG',
    specs: [
      'Dual Garmin GTN650',
      'Aspen PFD',
      'Excellent Leather interior',
      '350/hr Wet'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/1c35c281578d154ff565b9a8a00c2d5d.jpeg',
        alt: '1959 Cessna 310C N413DG exterior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/a20e062a903f01672a93caed260db5fb.jpeg',
        alt: '1959 Cessna 310C N413DG cockpit'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/98fb306de54bf8a4cb90ea3ff7cb8d85.jpeg',
        alt: '1959 Cessna 310C N413DG front view'
      }
    ]
  },
  {
    id: 7,
    name: 'Decathlon',
    tailNumber: 'N113JF',
    specs: [
      '150hp Constant Speed',
      'Aluminum Spar Wing - New Style Ailerons',
      'Excellent Interior'
    ],
    images: [
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/1c41851bacd85c859f637815f8ea1038.jpeg',
        alt: 'Decathlon N113JF exterior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/8bab15a819820cf189b51dd3c5ce6b66.jpeg',
        alt: 'Decathlon N113JF interior'
      },
      {
        url: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/222028cd9049a5e86cc7d69a4e2c940a.jpeg',
        alt: 'Decathlon N113JF front view'
      }
    ]
  }
];

export default function Gallery() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-blue-50 to-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Our Fleet
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our Fleet of Exceptional Aircraft
            </p>
          </div>
        </section>

        {/* Aircraft Fleet Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Left Column */}
              <div className="space-y-8">
                {leftColumnAircraft.map((aircraft) => (
                  <AircraftCard key={aircraft.id} aircraft={aircraft} />
                ))}
              </div>

              {/* Right Column */}
              <div className="space-y-8">
                {rightColumnAircraft.map((aircraft) => (
                  <AircraftCard key={aircraft.id} aircraft={aircraft} />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
